import React from 'react';

import {SelectEmail} from '../components/selectEmail';

export function SignupSelectEmail() {
  return <SelectEmail path="/signup/selected-email" />;
}
